module.exports = __webpack_public_path__ + "img/hr.168ee8b8.png";